import { useState } from "react";
import styled from "styled-components";
import { Utils, cartMultiReducer } from "@tiffin/app-common";
import { useAppSelector } from "../../hooks";
import { Alert, Button, Tooltip } from "antd";
import { DeliveryDetailsModal } from "@tiffin/components";
import EnvironmentOutlined from "@ant-design/icons/EnvironmentOutlined"
import { OrderType } from "@tiffin/core";

export const OrderDetails = styled(BaseOrderDetails)`
  padding: 0px 25px;
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  gap: 10px;
  overflow: hidden;

  @media (max-width:768px) {
    padding: 0;
    justify-content: space-between;
    width: 100%;
  }

  .address {
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 5px;
    font-weight: 500;
    text-overflow: ellipsis;
    overflow: hidden;
    align-items: center;
    padding: 10px 0;

    span {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
`

interface IBaseOrderDetails {
  className?: string,
  showDeliveryWarning?: boolean
}

function BaseOrderDetails({className, showDeliveryWarning}: IBaseOrderDetails) {

  const partner = useAppSelector((state) => state.store)
  const cart = useAppSelector((state) => partner.details?.id && state.cartMulti.carts[partner.details.id] ? state.cartMulti.carts[partner.details.id] : cartMultiReducer.EmptyCart);
  const cartStatus = useAppSelector((state) => state.cartMulti.status)

  const [showAddressModal, setShowAddressModal] = useState<boolean>(false)

  return (
    <div className={className}>
      {
        cart.orderType === OrderType.Pickup &&
        <div className="address">
          <EnvironmentOutlined />
          <span>Pickup from <b>{partner.details?.address}</b></span>
        </div>
      }
      {
        cart.orderType === OrderType.Delivery &&
        <>
          {
            cart.deliveryAddress ? 
            <div className="address">
              <EnvironmentOutlined />
              <span>Delivery to <Tooltip title={Utils.formatAddress(cart.deliveryAddress)}><b>{Utils.formatAddress(cart.deliveryAddress)}</b></Tooltip></span>        
            </div>
            :
            showDeliveryWarning ?
            <Alert showIcon type="error" message="Please add a delivery address" />
            :
            <div className="address">
              <EnvironmentOutlined />
              Add a delivery address
            </div>
          }
          <Button onClick={() => setShowAddressModal(true)}>{cart.deliveryAddress ? 'Change' : 'Add address'}</Button>
          {
            partner.details?.id && 
            <DeliveryDetailsModal
              isOpen={showAddressModal}
              onCancel={() => setShowAddressModal(false)}
              hideDatePicker={true}
              onAddressChange={() => setShowAddressModal(false)}
              cart={cart}
              cartStatus={cartStatus}
              isPartnerWebsite={true}
              partner={partner.details}
            />
          }
        </>
      }
    </div>
    )
}